<template>
	<div class="Box">
		<el-drawer :title="title" :close-on-click-modal="false" :visible.sync="dialogTableVisible" size="45%"
			:before-close="handleClose" :wrapperClosable="true">
			<div class="demo-drawer__content">
				<el-form :model="TurnitupObj" size="medium" label-width="100px" class="mt35" ref="ruleForm">
					<el-row :gutter="35" class="center-content">
						<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
							<el-form-item label="渠道号" prop="name" :label-width="formLabelWidth">
								<el-select v-model="codes" placeholder="请选择" clearable class="w100"
									@change="optionchange" default-first-option>
									<el-option v-for="item in options" :key="item.rowid" :label="item.code"
										:value="item.code"> </el-option>
								</el-select>
							</el-form-item>
						</el-col>

						<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
							<el-form-item label="推广链接名称" prop="name" :label-width="formLabelWidth">
								<div class="input-with-button">
									<el-input v-model="TurnitupObj.channel_name" clearable :disabled="true"></el-input>

									<img class="img_fz" src="../../../../assets/btn/zhantie.png" alt=""
										@click="addput(TurnitupObj.channel_name)" />
								</div>
							</el-form-item>
						</el-col>

						<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
							<el-form-item label="投放计划" prop="name" :label-width="formLabelWidth">
								<div class="input-with-button">
									<el-input v-model="TurnitupObj.adplan_name" clearable :disabled="true"></el-input>

									<img class="img_fz" src="../../../../assets/btn/zhantie.png" alt=""
										@click="addput(TurnitupObj.adplan_name)" />
								</div>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
							<el-form-item label="推广平台" prop="name" :label-width="formLabelWidth">
								<div class="input-with-button">
									<el-input v-model="TurnitupObj.platform" clearable :disabled="true"></el-input>
									<img class="img_fz" src="../../../../assets/btn/zhantie.png" alt=""
										@click="addput(TurnitupObj.platform)" />
								</div>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
							<el-form-item label="小程序名称" prop="name" :label-width="formLabelWidth">
								<div class="input-with-button">
									<el-input v-model="TurnitupObj.app_name" clearable :disabled="true"></el-input>
									<img class="img_fz" src="../../../../assets/btn/zhantie.png" alt=""
										@click="addput(TurnitupObj.app_name)" />
								</div>
							</el-form-item>
						</el-col>
						<el-col v-if="TurnitupObj.origin_id" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
							<el-form-item label="小程序原始ID" prop="name" :label-width="formLabelWidth">
								<div class="input-with-button">
									<el-input v-model="TurnitupObj.origin_id" clearable :disabled="true"></el-input>
									<img class="img_fz" src="../../../../assets/btn/zhantie.png" alt=""
										@click="addput(TurnitupObj.origin_id)" />
								</div>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
							<el-form-item label="小程序APPID" prop="name" :label-width="formLabelWidth">
								<div class="input-with-button">
									<el-input v-model="TurnitupObj.app_id" clearable :disabled="true"></el-input>
									<img class="img_fz" src="../../../../assets/btn/zhantie.png" alt=""
										@click="addput(TurnitupObj.app_id)" />
								</div>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
							<el-form-item label="小程序启动路径" prop="name" :label-width="formLabelWidth">
								<div class="input-with-button">
									<el-input v-model="TurnitupObj.app_page" clearable :disabled="true"></el-input>
									<img class="img_fz" src="../../../../assets/btn/zhantie.png" alt=""
										@click="addput(TurnitupObj.app_page)" />
								</div>
							</el-form-item>
						</el-col>

						<el-col  :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
							<el-form-item label="小程序启动参数" prop="name" :label-width="formLabelWidth">
								<div class="input-with-button">
									<el-input type="textarea" autosize v-model="TurnitupObj.app_param" clearable
										:disabled="true"></el-input>
									<img class="img_fz" src="../../../../assets/btn/zhantie.png" alt=""
										@click="addput(TurnitupObj.app_param)" />
								</div>
							</el-form-item>
						</el-col>
						<el-col v-if="TurnitupObj.app_link" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
							<el-form-item label="小程序路径参数" autosize prop="name" :label-width="formLabelWidth">
								<div class="input-with-button">
									<el-input type="textarea" v-model="TurnitupObj.app_link" clearable autosize 
										:disabled="true"></el-input>
									<img class="img_fz" src="../../../../assets/btn/zhantie.png" alt=""
										@click="addput(TurnitupObj.app_link)" />
								</div>
							</el-form-item>
						</el-col>
						<el-col v-if="TurnitupObj.dy_page" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
							<el-form-item label="抖音小程序调起链接" autosize prop="name" :label-width="formLabelWidth">
								<div class="input-with-button">
									<el-input type="textarea" v-model="TurnitupObj.dy_page" clearable autosize
										:disabled="true"></el-input>
									<img class="img_fz" src="../../../../assets/btn/zhantie.png" alt=""
										@click="addput(TurnitupObj.dy_page)" />
								</div>
							</el-form-item>
						</el-col>
						<el-col v-if="TurnitupObj.wx_novel_page" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
							<el-form-item label="微信阅读器调起链接" autosize prop="name" :label-width="formLabelWidth">
								<div class="input-with-button">
									<el-input type="textarea" v-model="TurnitupObj.wx_novel_page" clearable autosize
										:disabled="true"></el-input>
									<img class="img_fz" src="../../../../assets/btn/zhantie.png" alt=""
										@click="addput(TurnitupObj.wx_novel_page)" />
								</div>
							</el-form-item>
						</el-col>
						<el-col v-if="TurnitupObj.wx_page" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
							<el-form-item label="微信小程序调起链接" autosize prop="name" :label-width="formLabelWidth">
								<div class="input-with-button">
									<el-input type="textarea" v-model="TurnitupObj.wx_page" clearable autosize
										:disabled="true"></el-input>
									<img class="img_fz" src="../../../../assets/btn/zhantie.png" alt=""
										@click="addput(TurnitupObj.wx_page)" />
								</div>
							</el-form-item>
						</el-col>
						<!-- <el-col v-if="TurnitupObj.tt_jc" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
							<el-form-item label="头条监测链接1.0" prop="name" :label-width="formLabelWidth">
								<div class="input-with-button">
									<el-input type="textarea" v-model="TurnitupObj.tt_jc" clearable autosize
										:disabled="true"></el-input>
									<img class="img_fz" src="../../../../assets/btn/zhantie.png" alt=""
										@click="addput(TurnitupObj.tt_jc)" />
								</div>
							</el-form-item>
						</el-col> -->
						<el-col v-if="TurnitupObj.tt_jc2" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
							<el-form-item label="头条监测链接2.0" prop="name" :label-width="formLabelWidth">
								<div class="input-with-button">
									<el-input type="textarea" v-model="TurnitupObj.tt_jc2" autosize clearable 
										:disabled="true"></el-input>
									<img class="img_fz" src="../../../../assets/btn/zhantie.png" alt=""
										@click="addput(TurnitupObj.tt_jc2)" />
								</div>
							</el-form-item>
						</el-col>
						<!-- <el-col v-if="TurnitupObj.bd_us" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
							<el-form-item label="百度获取urlScheme地址" prop="name"  :label-width="formLabelWidth">
								<div class="input-with-button">
									<el-input type="textarea" v-model="TurnitupObj.bd_us" autosize clearable
										:disabled="true"></el-input>
									<img class="img_fz" src="../../../../assets/btn/zhantie.png" alt=""
										@click="addput(TurnitupObj.bd_us)" />
								</div>
							</el-form-item>
						</el-col>
						<el-col v-if="TurnitupObj.bd_jc" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
							<el-form-item label="百度监测链接（微信投放使用）" prop="name" :label-width="formLabelWidth">
								<div class="input-with-button">
									<el-input type="textarea" v-model="TurnitupObj.bd_jc" autosize clearable
										:disabled="true"></el-input>
									<img class="img_fz" src="../../../../assets/btn/zhantie.png" alt=""
										@click="addput(TurnitupObj.bd_jc)" />
								</div>
							</el-form-item>
						</el-col> -->
						<!-- <el-col :xs="24" :sm="12" :md="8" :lg="21" :xl="20" class="mb20">
						<el-form-item label="调起短链" prop="name" autosize>
							<div class="input-with-button">
								<el-input type="textarea" v-model="TurnitupObj.launch_short" clearable :disabled="true"></el-input>
								<img class="img_fz" src="../../../../assets/btn/zhantie.png" alt="" @click="addput(TurnitupObj.launch_short)" />
							</div>
						</el-form-item>
					</el-col> -->
					</el-row>
				</el-form>
			</div>

			<div class="demo-drawer__footer">
				<el-button @click="handleClose">取 消</el-button>
			</div>

		</el-drawer>
	</div>
</template>

<script>
import { channelNumberAPI } from '@/api/popularize/channelNumber';
import { processErrors } from "@/utils/errorHandler";

export default {
	props: ['dialogTableVisible', 'channel_code', 'codeList', 'seeid'],
	components: {},
	data() {
		return {
			formLabelWidth: "140px",
			title: '调起链接',
			SeeFrom: {
				name: '',
			},
			flag: false,
			codes: '',
			options: [],
			optionID: '',
			TurnitupObj: {},
			// tex:this.TurnitupObj[0].code
		};
	},
	methods: {
		optionchange(e) {
			let obj = {
				id: this.optionID,
				channel_code: e,
			};
			let api = channelNumberAPI();
			api.Turnitup(obj).then((res) => {
				if (res.code == 0) {
					this.TurnitupObj = res.data;
				} else {
					processErrors(res);
				}
			});
		},
		handleClose(done) {
			this.$emit('NoneDlog');
		},
		AddNone() {
			this.$emit('NoneDlog');
		},
		addput(name) {
			if (navigator.clipboard && window.isSecureContext) {
				navigator.clipboard
					.writeText(name)
					.then(() => {
						// 复制成功
						this.$message.success('复制成功！');
					})
					.catch((err) => {
						// 复制失败
						this.$message.error('复制失败！');
					});
			} else {
				// 浏览器不支持剪贴板API
				this.$message.error('当前浏览器不支持复制到剪贴板功能！');
			}
		},
	},

	mounted() {
		// this.TurnitupObj.channel_code = this.channel_code;
		this.options = this.codeList;
		this.optionID = this.seeid;

		// this.channel_code = row.channel_code_list;
		let obj = {
			id: this.optionID,
			channel_code: this.options[0].code,
		};
		let api = channelNumberAPI();
		api.Turnitup(obj).then((res) => {
			if (res.code == 0) {
				this.TurnitupObj = res.data;
				this.codes = this.options[0].code; // 设置codes为第一项的code值
			} else {
				processErrors(res);
			}
		});
	},
};
</script>
<style lang="scss" scoped>
.Box {
	& ::v-deep .el-dialog {
		.el-dialog__body {
			padding: 0 !important;
		}
	}
}

.image {
	width: 15px;
	height: 15px;
}

.input-with-button {
	display: flex;
	align-items: center;
}

.input-with-button .el-input {
	flex: 1;
}

.input-with-button .el-button {
	margin-left: 10px;
	/* 你可以根据需要调整间距 */
}

.img_fz {
	width: 20px;
	height: 20px;
	cursor: pointer;
	margin-left: 10px;
}

.center-content {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
}

.center-content .el-col {
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.demo-drawer__footer {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	padding: 10px;
	text-align: center;
}

.demo-drawer__footer .el-button {
	//flex: 1; /* 让按钮平分容器宽度 */
	width: 320px;
	/* 设置按钮宽度为120px */
}

.demo-drawer__content {
	height: calc(100% - 80px);
	/* 给内容区域设置高度,留出按钮区域 */
	overflow-y: auto;
	/* 添加垂直滚动条 */
	margin-top: 20px;
	margin-left: 20px;
	margin-right: 20px;
	overflow-x: hidden;
}
</style>
